import PrepareReturnApi from '../../../../services/api/prepareReturnApi'
import { trackEvent } from '../../../../services/util/AnalyticsUtil';
import { TaskStatus } from '../TaskStatus'

/* Service class used to perform api calls for messaging */
class PrepareService {
    constructor() {
        this.api = PrepareReturnApi.create();
        this._isCompleting = false;
        this._isResetting = false;
    }

    /**
     * Attempts to complete the prepare return workflow task for this ticket
     * @param {any} ticketId
     * @param {any} payload
     */
    async completePrepareTask(ticketId, payload) {
        var status = true;
        var extraFiles = null;
        var missingFiles = null;
        if (!this._isCompleting) {
            this._isCompleting = true
            try {
                var response = await this.api.completePrepareReturnTask(ticketId, payload)
                if (response && response.ok) {
                    if (response.data.status === TaskStatus.COMPLETE) {
                        status = true
                        this.trackAdditionalDocsEvents(ticketId, response.data.completionData)
                    } else {
                        if (response.data && response.data.extraFiles && response.data.extraFiles.length > 0) {
                            extraFiles = response.data.extraFiles
                        }
                        if (response.data && response.data.missingFiles && response.data.missingFiles.length > 0) {
                            missingFiles = response.data.missingFiles
                        }
                        status = false;
                    }
                } else {
                    status = false
                }
            } catch (ex) {
                status = false;
            } finally {
                this._isCompleting = false;
            }            
        }

        return {
            status: status,
            extraFiles: extraFiles,
            missingFiles: missingFiles
        }
    }

    trackAdditionalDocsEvents(ticketId, completionDataJSON) {
        if (completionDataJSON) {
            try {
                var completionData = JSON.parse(completionDataJSON)
                if (completionData && completionData.additionalDocuments) {
                    for (var doc in completionData.additionalDocuments) {
                        if (!['T1_P', 'T1_S', 'TP1_P', 'TP1_S', 'T183_P', 'T183_S', 'TP1000_P', 'TP1000_S'].includes(doc)) {
                            trackEvent(doc, ticketId)
                        }
                    }
                }
            } catch (err) { }
        }
    }

    async resetPrepareTask(ticketId) {
        var status = true;
        if (!this._isResetting) {
            this._isResetting = true;
            try {
                var response = await this.api.resetPrepareReturnTask(ticketId)
                if (response && response.ok) {
                    status = true
                } else {
                    status = false;
                }
            } catch (ex) {
                status = false;
            } finally {
                this._isResetting = false;
            }  
        }

        return status;        
    }
}

const prepareService = new PrepareService();
export default prepareService;